
import {loadManifest} from '@angular-architects/module-federation';
import {environment} from './environments/environment';

const local = true;
loadManifest(local ? `${environment.cdn}/mf/${environment.mf}` : 'assets/mf.manifest.json')
  .catch((err) => console.error('Error loading remote entries', err))
  .then(() => import('./bootstrap'))
  .catch((err) => console.error(err));
